import { ThunkAction } from 'redux-thunk';

import { comparisonForHighlightSave } from '../services/contractApi';

/**
 * ファイル比較用モジュール
 */
export interface ComparisonStateForHighlightSave {
  saveStatus: number;
}

const initialState: ComparisonStateForHighlightSave = {
  saveStatus: 0,
};

const REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE = 'REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE';
type REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE = typeof REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE;

const RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE = 'RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE';
type RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE = typeof RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE;

const FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE = 'FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE';
type FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE = typeof FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE;

const CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE = 'CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE';
type CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE = typeof CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE;

const CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE = 'CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE';
type CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE = typeof CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE;

interface RequestComparisonForHighlightSave {
  type: REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE;
}

interface ReceiveComparisonForHighlightSave {
  type: RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE;
  status: number;
}

interface FailComparisonForHighlightSave {
  type: FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE;
  status: number;
}

interface ClearComparisionForHighlightSave {
  type: CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE;
}

interface ClearComparisionMessagesForHighlightSave {
  type: CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE;
}

export type ComparisonAction = RequestComparisonForHighlightSave | ReceiveComparisonForHighlightSave |
  FailComparisonForHighlightSave | ClearComparisionForHighlightSave | ClearComparisionMessagesForHighlightSave;

type CompareDocumentsForHighlightSave =
  ThunkAction<void, ComparisonStateForHighlightSave, undefined, ComparisonAction>;

export function requestComparisonForHighlightSave(): RequestComparisonForHighlightSave {
  return {
    type: REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE,
  };
}

export function receiveComparisonForHighlightSave(status: number): ReceiveComparisonForHighlightSave {
  return {
    status,
    type: RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE,
  };
}

export function failComparisonForHighlightSave(status: number): FailComparisonForHighlightSave {
  return {
    status,
    type: FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE,
  };
}

export function clearComparisionForHighlightSave(): ClearComparisionForHighlightSave {
  return {
    type: CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE,
  };
}

export function clearComparisionMessagesForHighlightSave(): ClearComparisionMessagesForHighlightSave {
  return {
    type: CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE,
  };
}

export function compareDocumentsForHighlightSave(): CompareDocumentsForHighlightSave {
  return (dispatch) => {
    dispatch(requestComparisonForHighlightSave());
    // 比較API呼び出し
    return comparisonForHighlightSave().then((res) => {
      const { status, status_code } = res;
      if (status === 200) {
        dispatch(receiveComparisonForHighlightSave(status));
      } else {
        dispatch(failComparisonForHighlightSave(status_code));
      }
    }).catch((err) => {
      dispatch(failComparisonForHighlightSave(500));
    });
  };
}

export default function reducer(
  state: ComparisonStateForHighlightSave | undefined,
  action: ComparisonAction,
): ComparisonStateForHighlightSave {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_COMPARISON_FOR_HIGHLIGHT_SAVE: {
      return state;
    }
    case RECEIVE_COMPARISON_FOR_HIGHLIGHT_SAVE: {
      const { status } = action;
      return { saveStatus: status };
    }
    case FAIL_COMPARISON_FOR_HIGHLIGHT_SAVE: {
      const { status } = action;
      return { ...state, saveStatus: status };
    }
    case CLEAR_COMPARISON_FOR_HIGHLIGHT_SAVE: {
      return initialState;
    }
    case CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT_SAVE: {
      return { ...state };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/comparisonHighlightSave.ts